@if (!isEmpty(eAddresses)) {
  @for (address of getEAddressTypeMail(eAddresses); track address) {
    <div><his-display-email value="{{address.eaddress}}"></his-display-email></div>
  }
  @for (address of getEAddressTypePhone(eAddresses); track address) {
    <div><his-display-phone value="{{address.eaddress}} ({{address.type.defaulttext}})"></his-display-phone></div>
  }
  @for (address of getEAddressTypeWeb(eAddresses); track address) {
    <div><his-display-weblink value="{{address.eaddress}}"></his-display-weblink></div>
  }
}
